// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { Badge, flat, Typography } from '@kintent/glide';

import HomePageContainer from './HomePageContainer';

export const SubprocessorsSectionContainer = styled(HomePageContainer)`
  margin-top: 40px;
`;

export const DescriptionLabel = styled(Typography)`
  color: ${({ theme }) => flat(theme.color.system.gray, '80%')};
`;

export const CountBadge = styled(Badge)`
  background-color: ${({ theme }) => theme.components.header.primaryCTAButton.background};
`;
